export const Christmas = () => {
    return (
        <>
            <div className="row p-5" id="event_photo_five"  style={{background:"#d3d3d3"}}>

                <div className="col-12 col-md-10 mx-auto py-4">
                    <h3 className="fw-bold colorcharchol text-center">Christmas</h3>

                    <div className="zoom-in-out-box2 m-auto">
                        <hr />
                    </div>
                </div>

                <div className=" col-12 col-md-6 col-lg-3 ds">
                    <div className="gallery-item mb-3">
                        <div>
                            <a href="Assets/Images/event/santa-claus4-01.jpg" className="thumbnail">
                                <span>
                                    <img src="Assets/Images/event/santa-claus4-01.jpg" alt="" />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className=" col-12 col-md-6 col-lg-3 ds">
                    <div className="gallery-item mb-3">
                        <div>
                            <a href="Assets/Images/event/santa-claus3-01.jpg" className="thumbnail">
                                <span>
                                    <img src="Assets/Images/event/santa-claus3-01.jpg" alt="" />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className=" col-12 col-md-6 col-lg-3 ds">
                    <div className="gallery-item mb-3">
                        <div>
                            <a href="Assets/Images/event/santa-claus2-01.jpg" className="thumbnail">
                                <span>
                                    <img src="Assets/Images/event/santa-claus2-01.jpg " alt="" />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className=" col-12 col-md-6 col-lg-3 ds">
                    <div className="gallery-item mb-3">
                        <div>
                            <a href="Assets/Images/event/santa-claus-01.jpg" className="thumbnail">
                                <span>
                                    <img src="Assets/Images/event/santa-claus-01.jpg" alt="" />
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}